<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc('message.prestation',2) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <b-container>
            <b-row>
              <b-col col sm="12">
                <section class="container" id="appointment-table">
                  <div class="appointment-table-header my-2 mb-4">
                    <b-input-group
                        size="sm"
                        class="mb-3 width-270"
                    >
                      <b-form-input
                          type="text"
                          size="sm"
                          class="p-2 h-100"
                          :placeholder="$t('message.filter') + '...'"
                          v-model="filterCriteria"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                            size="sm"
                            text="Button"
                            variant="primary"
                            @click="handlerOnFilterButton"
                        >
                          Go
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div class="row">
                      <div class="col-3 ">
                        <div class=" ">
                        <b-button @click="handleOnAddClick" v-if="can || hasAssistante">
                          <i class="fa fa-plus edit-icon"></i>
                          {{ $t('message.add') }}
                        </b-button>
                        </div>
                      </div>
                      <div class="col-9 overflow-auto">
                        <div class="ml-1">


                          <div
                              v-if="paginationObject.numOfPages > 1"
                              class="pagination-wrapper d-inline-block"
                          >
                            <div class="pagination">
                              <a
                                  href="#"
                                  :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                  @click="_handlePaginationClick('prev')"
                              >
                                <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                              </a>
                              <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                            :key="key"
                                                            aria-current="page"
                                                            class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                </template>
                                <template v-else>
                                  <a
                                      href="#"
                                      :key="key"
                                      class="page-numbers"
                                      @click="_handlePaginationClick(pageNumber)"
                                  >
                                    {{ pageNumber }}
                                  </a>
                                </template>
                              </template>
                              <a
                                  href="#"
                                  class="next page-numbers"
                                  :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                  @click="_handlePaginationClick('next')"
                              >
                                <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row appointment-table-content">
                    <div class="container-fluid">
                      <template
                          v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                      >
                        <div
                            v-for="(bill, key) in paginationObject.display(paginationObject.currentPageNumber)"
                            :key="key"
                            class="row appointment-item hovered"
                            @click="onEtablissementClick(bill.slug)"
                        >
                          <div class="col-lg-6">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomPrestation') }}
                                                        </span>
                            <h4
                                class="appointment-hour"
                            >
                              {{ bill.name }}
                            </h4>
                          </div>
                          <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.price') }}
                                                        </span>
                            <h4>{{ _displayNumber(bill.price) }}</h4>
                          </div>
                          <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.reduction') }}
                                                        </span>
                            <h4>{{ _displayNumber(bill.reduction) }}</h4>
                          </div>
                        </div>
                      </template>

                      <template v-else>
                        <h4>{{ $t('message.noItemToDisplay') }}</h4>
                      </template>

                    </div>
                  </div>
                </section>

                <!--<vue-good-table
                        id="operation"
                        :columns="etablissementColumns"
                        :rows="etablissementRows"
                        :search-options="{
                        enabled:true,
                        }"
                        :pagination-options="paginationOptions"
                        @on-row-click="onEtablissementClick"
                />-->
              </b-col>
            </b-row>
          </b-container>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import { pagination, handlePaginationClick } from "../../helpers/paginations";
import { displayNumber } from "../../helpers/general";

export default {
  name: "ListPrestationOfInstitution",

  computed: {
    ...mapGetters(['hasAdminRole',"institution",
      'hasGestionnaireRole','hasMedecinControleRole','isComptable','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
    },

    etablissementColumns: function () {
      return [
        {
          label: this.$i18n.t('message.nomEtablissement'),
          field: 'nom',
        },
        {
          label: this.$i18n.t('message.nomPrestation'),
          field: 'nomPrestation',
        },
        {
          label: this.$i18n.t('message.price'),
          field: 'prix',
        },
        {
          label: this.$i18n.t('message.reduction'),
          field: 'reduction',
        }
      ];
    },

    etablissementRows: function() {
      let iArray = [];
      // let self = this;
      _.forEach(this.userInstitutions, function(institution) {
        let i = {};
        _.forEach(institution.prestations, function (prestation) {
          i.nom = institution.name;
          i.slug = prestation.slug;
          i.nomPrestation = prestation.prestation.nom;
          i.prix = prestation.prix;
          i.reduction = prestation.reduction;
          iArray.push(i);
        })

      });
      return _.uniqBy(iArray, item => item.name);
    },
  },

  data(){
    return {
      filterCriteria: '',
      bills: [],
      institutionSlug: this.$route.params.prestation_etablissement,
      paginationObject: {},
      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },
    }
  },

  watch: {
    institution: function (newValue, oldValue) {
      // this.bills = _.uniqBy(iArray, item => item.name);
      this.bills = newValue.prestations.map(prestation => ({
        slug: prestation.slug,
        price: prestation.prix,
        reduction: prestation.reduction,
        name: prestation.prestation.nom,
      }));
    },

    bills: function (newValue, oldValue) {
      this.paginationObject = pagination(newValue);
    },

    filterCriteria: function (newValue, oldValue) {
      this.handleFilter(newValue);
    }
  },

  methods:{
    handleOnAddClick() {
      this.$router.push({ name: 'add-etablissement-prestations',query:{etablissement:this.institution.id} });
    },

    handlerOnFilterButton() {
      event.preventDefault();
      this.handleFilter(this.filterCriteria);
    },

    _handlePaginationClick(action) {
      this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
    },

    handleFilter(value) {
      if (value) {
        const newBills = this.bills.filter(app => {
          let result = false;

          if (app.name) {
            result = result || app.name.toLowerCase().includes(value.toLowerCase());
          }

          if (app.price) {
            result = result || app.price.toLowerCase().includes(value.toLowerCase());
          }

          if (app.reduction) {
            result = result || app.reduction.toLowerCase().includes(value.toLowerCase());
          }

          return result;
        });

        this.paginationObject = pagination(newBills, 2);
      } else {
        this.paginationObject = pagination(this.bills, 2);
      }
    },

    onEtablissementClick(slug){
      this.$router.push({ name: 'etablissement-prestation', params: { prestation_etablissement: slug } });
    },

    getInstitution: function() {
      const args = {
        institution: this.institutionSlug
      };
      const errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getInstitution', { args, errorMessages });
    },

    _displayNumber: displayNumber,
  },

  mounted() {
    this.getInstitution();
  }
}
</script>

<style scoped>

</style>
